import { render, staticRenderFns } from "./SvgMark.vue?vue&type=template&id=29157eb8&scoped=true&"
import script from "./SvgMark.vue?vue&type=script&lang=js&"
export * from "./SvgMark.vue?vue&type=script&lang=js&"
import style0 from "./SvgMark.vue?vue&type=style&index=0&id=29157eb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29157eb8",
  null
  
)

export default component.exports